import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';


const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const ActivityAuditingToolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const history = useHistory();

  const { langActivityAuditing } = useSelector((state) => state.locale);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.title}
          variant="h2"
        >
          {langActivityAuditing.titleActivityAuditingList}
        </Typography>
        <span className={classes.spacer} />
      </div>
      
    </div>
  );
};

ActivityAuditingToolbar.propTypes = {
  className: PropTypes.string
};

export default ActivityAuditingToolbar;
